import { Reveal } from "./Reveal";
import { InviteMockup, SeatingMockup, CheckoutMockup } from "./Mockups";

const FEATURES = [
  {
    step: "Passo 01",
    title: "Crea l'evento e invita in un click.",
    body: "Invia un unico link elegante. Raccogli conferme, intolleranze alimentari e necessità di pernotto in automatico.",
    visual: <InviteMockup />,
  },
  {
    step: "Passo 02",
    title: "Risolvi il puzzle dei tavoli.",
    body: "L'algoritmo fa il lavoro sporco. Trascina i contatti: la planimetria per il catering si genera in pochi secondi.",
    visual: <SeatingMockup />,
  },
  {
    step: "Passo 03",
    title: "Gestisci regali e paga in sicurezza.",
    body: "Ricevi i regali tramite una Busta Digitale elegante e paga i fornitori sfruttando la protezione totale Escrow.",
    visual: <CheckoutMockup />,
  },
];

export default function HowItWorks() {
  return (
    <section id="come-funziona" className="py-24 sm:py-32" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 space-y-28 sm:space-y-36">
        {FEATURES.map((f, i) => (
          <div
            key={f.step}
            className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center"
            data-testid={`feature-row-${i + 1}`}
          >
            <Reveal className={i % 2 === 1 ? "lg:order-2" : ""}>
              <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#C2492F]">
                {f.step}
              </p>
              <h3 className="font-display text-3xl sm:text-4xl tracking-tight text-[#1A1A1A] mt-4">
                {f.title}
              </h3>
              <p className="text-base text-gray-500 leading-relaxed mt-5 max-w-md">{f.body}</p>
            </Reveal>
            <Reveal delay={0.15} className={i % 2 === 1 ? "lg:order-1" : ""}>
              {f.visual}
            </Reveal>
          </div>
        ))}
      </div>
    </section>
  );
}
